var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / PH") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-PH",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333333,10 L12.445,9.33333333 L28,9.33333333 L28,20 L0,20 L13.3333333,10 Z",
    id: "Combined-Shape",
    fill: "#DD1C34",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,0 L28,9.33333333 L12.444,9.333 L0,0 L28,0 Z",
    id: "Combined-Shape",
    fill: "#0D4BC3",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,16 C2.36818983,16 2.66666667,16.2984768 2.66666667,16.6666667 C2.66666667,17.0348565 2.36818983,17.3333333 2,17.3333333 C1.63181017,17.3333333 1.33333333,17.0348565 1.33333333,16.6666667 C1.33333333,16.2984768 1.63181017,16 2,16 Z M5.94227811,6.92040156 L5.51048834,8.96759973 C5.57944275,9.02402595 5.64264072,9.08722392 5.69906693,9.15617833 L7.74626511,8.72438856 L5.99340235,9.86652286 C5.99776586,9.91042359 6,9.95495089 6,10 C6,10.0453956 5.99773136,10.0902614 5.99330127,10.1344901 L7.74626511,11.2756114 L5.69906693,10.8438217 C5.64264072,10.9127761 5.57944275,10.9759741 5.51048834,11.0324003 L5.94227811,13.0795984 L4.80115679,11.3266346 C4.75692808,11.3310647 4.71206231,11.3333333 4.66666667,11.3333333 C4.62161756,11.3333333 4.57709026,11.3310992 4.53318952,11.3267357 L3.39105523,13.0795984 L3.822845,11.0324003 C3.75389058,10.9759741 3.69069262,10.9127761 3.6342664,10.8438217 L1.58706822,11.2756114 L3.34003206,10.1344901 C3.33560197,10.0902614 3.33333333,10.0453956 3.33333333,10 C3.33333333,9.95495089 3.33556747,9.91042359 3.33993099,9.86652286 L1.58706822,8.72438856 L3.6342664,9.15617833 C3.69069262,9.08722392 3.75389058,9.02402595 3.822845,8.96759973 L3.39105523,6.92040156 L4.53318952,8.67326432 C4.57709026,8.6689008 4.62161756,8.66666667 4.66666667,8.66666667 C4.71206231,8.66666667 4.75692808,8.66893531 4.80115679,8.67336539 L5.94227811,6.92040156 Z M10,9.33333333 C10.3681898,9.33333333 10.6666667,9.63181017 10.6666667,10 C10.6666667,10.3681898 10.3681898,10.6666667 10,10.6666667 C9.63181017,10.6666667 9.33333333,10.3681898 9.33333333,10 C9.33333333,9.63181017 9.63181017,9.33333333 10,9.33333333 Z M2,2.66666667 C2.36818983,2.66666667 2.66666667,2.9651435 2.66666667,3.33333333 C2.66666667,3.70152317 2.36818983,4 2,4 C1.63181017,4 1.33333333,3.70152317 1.33333333,3.33333333 C1.33333333,2.9651435 1.63181017,2.66666667 2,2.66666667 Z",
    id: "Oval-206",
    fill: "#FDD64D",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPh);
export default __webpack_public_path__ + "static/media/PH.4788015e608ada96c3103a13d3442a01.svg";
export { ForwardRef as ReactComponent };